import axios from '@/libs/api.request'
var qs = require('qs');
//省列表
export const fetchProvinceList = () => {
    return axios.request({
        url: '/address/province',
        method: 'post'
    })
};

//市列表
export const fetchCityList = (params) => {
    let data = params;
    data = qs.stringify(data)
    return axios.request({
        url: '/address/city',
        data,
        method: 'post'
    })
};

//区、县列表
export const fetchAreaList = (params) => {
    let data = params;

    data = qs.stringify(data)
    return axios.request({
        url: '/address/area',
        data,
        method: 'post'
    })
};
//校区
export const fetchSchoolList = (params) => {
    let data = params;

    data = qs.stringify(data)
    return axios.request({
        url: '/school/platforml-school',
        data,
        method: 'post'
    })
};
//代理
export const fetchProxyList = (params) => {
    let data = params;

    data = qs.stringify(data)
    return axios.request({
        url: '/school/school-proxy',
        data,
        method: 'post'
    })
};
//课程类型下拉
export const fetchLessonTypeList = (params) => {
    let data = params;

    data = qs.stringify(data)
    return axios.request({
        url: '/lesson-type/lesson-type-list',
        data,
        method: 'post'
    })
};
//课程下拉
export const fetchLessonList = (params) => {
    let data = params;

    data = qs.stringify(data)
    return axios.request({
        url: '/lesson/lesson-down',
        data,
        method: 'post'
    })
};
//老师下拉
export const fetchTeacherList = (params) => {
    let data = params;

    data = qs.stringify(data)
    return axios.request({
        url: '/teacher/list',
        data,
        method: 'post'
    })
};
//学生下拉
export const fetchUserList = () => {
    return axios.request({
        url: '/teacher-video/student-list',

        method: 'post'
    })
};
//下载
export const uploadFile = (params) => {
    let data = qs.stringify(params)
    return axios.request({
        url: '/system/storage',
        data,
        method: 'post'
    })
}